// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3zT4F","container":"styles_container__pbhiV","title":"styles_title__BuhFp","wrapper":"styles_wrapper__5XPP1","answer":"styles_answer__1qcKN"};